import { Link } from "react-router-dom";

const plans = [
  { name: "トクトクプラン2", data: "30GB", price: "4,048円", feature: "5GB以下の月は自動割引" },
  { name: "コミコミプランバリュー", data: "35GB", price: "3,828円", feature: "10分通話・Pontaパス込み" },
];

const checks = [
  "直近3カ月のデータ使用量",
  "5GB以下の月が多いか",
  "1回10分以内の電話をよくかけるか",
  "自宅セット割や家族セット割を使えるか",
  "SIMだけで乗り換えるか、端末も購入するか",
];

export default function UqmobileArticle() {
  return (
    <>
      <section id="intro">
        <p className="text-[1.08em] leading-[1.9] text-foreground-900">毎月のスマホ代を見るたびに「もう少し安くならないかな」と思う。でも、ネットだけで申し込み、家族や親のスマホまで自分で設定するのは不安。そんな気持ちから、料金が高いと分かっていても乗り換えを先延ばしにしていませんか。</p>
        <p>UQ mobileは、au回線、店舗、30〜35GBの料金プラン、端末販売を残しながら、毎月の料金を見直したい人が選びやすい通信会社です。</p>
      </section>

      <section id="answer">
        <h2>au回線の安心感を残して、料金を下げたい人へ</h2>
        <p>UQ mobileはKDDIが提供するauのサブブランドです。<strong>au回線、UQ mobile取扱店舗、通話込みプラン、端末販売</strong>がそろっています。</p>
        <div className="not-prose my-7 overflow-hidden rounded-xl border border-background-300 bg-white"><div className="px-5 py-5"><span className="text-sm font-bold text-foreground-500">UQ mobileの強み</span><strong className="mt-2 block text-2xl leading-snug text-foreground-900">au回線・店舗・10分通話・端末購入</strong></div><div className="border-t border-background-300 bg-primary-50 px-5 py-4 text-[15px] leading-7 text-foreground-800">「安くしたい。でも安心感まで手放したくない」という人に向く、バランス型の選択肢です。</div></div>
      </section>

      <section id="price">
        <h2>料金プランは、使い方が異なる2種類</h2>
        <div className="not-prose my-7 overflow-x-auto border-y-2 border-foreground-900 bg-white"><table className="w-full min-w-[620px] border-collapse text-left"><thead className="bg-foreground-900 text-white"><tr><th className="px-4 py-3">プラン</th><th className="px-4 py-3">容量</th><th className="px-4 py-3">月額基本料</th><th className="px-4 py-3">特徴</th></tr></thead><tbody>{plans.map((plan) => <tr key={plan.name} className="border-t border-background-200"><th className="px-4 py-4 text-foreground-900">{plan.name}</th><td className="px-4 py-4">{plan.data}</td><td className="px-4 py-4 font-bold">{plan.price}</td><td className="px-4 py-4">{plan.feature}</td></tr>)}</tbody></table></div>
        <p className="text-sm text-foreground-600">税込。端末代、超過通話料、追加オプション料は別途。2026年9月20日確認。</p>
        <p>トクトクプラン2は、セット割やau PAY カードお支払い割を使って料金を下げる設計です。コミコミプランバリューは、複雑なセット割がなくても35GBと10分通話をまとめて使いやすいプランです。</p>
      </section>

      <section id="plan-choice">
        <h2>一人ならコミコミ、使用量に波があるならトクトク</h2>
        <p>コミコミプランバリューは月額3,828円で35GB、1回10分以内の国内通話、通常月額548円のPontaパスが含まれます。現在は新規加入などの条件を満たすと、最大13カ月間、月額3,168円になる「UQコミコミおトク割」もあります。</p>
        <p>トクトクプラン2は30GBまで使え、5GB以下の月は自動的に割引されます。対象の自宅セット割とau PAY カードお支払い割を適用した例では、5GB以下の月は1,628円、5GBを超えて30GBまでの月は2,728円です。</p>
        <aside><strong>割引後の金額だけで決めない。</strong><p>自宅セット割には対象のインターネットや電気サービスなどの条件があります。自宅回線を含めた総額で判断します。</p></aside>
      </section>

      <section id="store-family">
        <h2>家族で見直せて、困ったら店舗で相談できる</h2>
        <p>一人当たり月1,000円の差でも、家族4人なら年間4万8,000円です。UQ mobileには家族セット割や自宅セット割があり、家族全体の固定費を見直せます。</p>
        <p>電話番号はそのまま使えるのか、LINEや写真は消えないか。自分の回線だけならできても、親のスマホまで変更するのは不安という人もいます。</p>
        <p>UQ mobileを取り扱うau Style・auショップ、UQスポットなどでは、契約や故障・修理の相談ができます。設定やデータ移行などは有料または一部店舗で対象外となる場合があるため、来店前に確認してください。</p>
      </section>

      <section id="devices">
        <h2>乗り換えと一緒に、スマホも購入できる</h2>
        <p>UQ mobileでは、SIMだけでなくiPhoneやAndroid端末も販売しています。回線と端末を一緒に申し込めるため、購入先を別々に探す負担を減らせます。</p>
        <p>対象機種の購入と同時に、対象プランと増量オプションⅡへ加入するなどの条件を満たすと、「UQ mobileオンラインショップおトク割」が適用されます。機種や申込区分によっては、端末代から44,000円が割引される例もあります。</p>
        <p>「通信費を下げたい。でも古いスマホも買い替えたい」という人は、端末代と毎月の通信費を分けて確認し、最後に合計しましょう。</p>
      </section>

      <section id="return-program">
        <h2>端末の「実質○円」は、2年返却の金額か確認する</h2>
        <p>UQ mobileでは、一定期間後に端末を返却すると、残りの支払いが不要になる「スマホトクするプログラム」も利用できます。</p>
        <p>「実質47円」「実質5,547円」などの表示は、返却を前提とする端末代の場合があります。返却までに払う端末代、返却時の利用料・手数料、毎月の通信費を分けて確認してください。返却せず使い続ける場合は、完済までの端末代を確認します。</p>
        <p><Link to="/articles/return-program">2年返却の総額と返却条件を確認する →</Link></p>
      </section>

      <section id="iphone18">
        <h2>iPhone 18 Proは、持ち込みならUQ mobileで使える</h2>
        <p>現行のUQ mobile販売ラインアップにiPhone 18 Proは見当たりません。ただし、iPhone 18 Proと18 Pro Maxは、UQ mobileのeSIMで動作確認済みです。</p>
        <div className="not-prose my-7 rounded-xl border border-background-300 bg-white p-5"><ol className="m-0 space-y-3 pl-5 text-[15px] leading-7 text-foreground-800"><li>Apple StoreなどでiPhone 18 Proを購入する</li><li>UQ mobileではeSIMのみ申し込む</li><li>購入したiPhoneへUQ mobileの回線を設定する</li></ol></div>
        <p>最新のProモデルが欲しい人は「Appleで端末購入＋UQ mobileのeSIM」。端末代を抑えたい人は「UQ mobileの割引対象端末」。二つの買い方から選べます。</p>
      </section>

      <section id="campaigns">
        <h2>今ならSIMだけの乗り換えで2万円相当還元</h2>
        <p>2026年9月17日から、条件を満たしてSIMカードまたはeSIMだけを他社から乗り換えると、20,000円相当のau PAY残高が還元されます。</p>
        <div className="not-prose my-7 rounded-xl border border-background-300 bg-white"><div className="border-b border-background-300 bg-background-100 px-4 py-3"><strong className="text-sm text-foreground-900">主な適用条件</strong></div><ul className="m-0 list-none divide-y divide-background-200 p-0"><li className="px-4 py-3.5">auまたはpovo以外からの乗り換え</li><li className="px-4 py-3.5">SIMカードまたはeSIMだけを契約</li><li className="px-4 py-3.5">コミコミプランバリューまたはトクトクプラン2を契約</li><li className="px-4 py-3.5">増量オプションⅡへ同時加入</li></ul></div>
        <p>増量オプションⅡは通常月額550円ですが、現在は適用月から7カ月間無料です。今のスマホをそのまま使える人なら、端末を買わずに回線だけを変更し、2万円相当の還元を受けられる可能性があります。</p>
      </section>

      <section id="before-change">
        <h2>申し込む前に、5つだけ確認</h2>
        <div className="not-prose my-7 rounded-xl border border-background-300 bg-white"><ul className="m-0 list-none p-0">{checks.map((item, index) => <li key={item} className={`flex items-start gap-3 px-4 py-4 ${index > 0 ? "border-t border-background-200" : ""}`}><span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-bold text-primary-600">{index + 1}</span><span className="text-[15px] leading-7 text-foreground-800">{item}</span></li>)}</ul></div>
        <p>キャンペーンを利用する場合は、乗り換え元、対象プラン、増量オプションⅡ、開通期限、au PAYの設定も確認してください。</p>
      </section>

      <section id="apply">
        <h2>安くしたい。でも失敗したくない人へ</h2>
        <p>乗り換えで一番大きな壁は、料金ではありません。「設定できなかったら困る」「親のスマホまで面倒を見られない」「知らない会社へ変えるのは不安」という気持ちです。</p>
        <p>UQ mobileは最安ではありません。それでも、au回線、店舗、30〜35GB、10分通話、端末購入までそろっています。</p>
        <p><strong>安さだけを追いかけて不安を抱えるより、安心して使い続けられる範囲で毎月の固定費を下げる。</strong>その一歩として、UQ mobileは検討する価値があります。</p>
        <div className="not-prose my-8 grid gap-3 sm:grid-cols-2"><a href="https://shop.uqmobile.jp/shop/cashback/" target="_blank" rel="noreferrer" className="flex items-center justify-between rounded-lg bg-primary-600 px-5 py-4 font-bold text-white hover:bg-primary-700">最新キャンペーンを確認する<span>↗</span></a><a href="https://shop.uqmobile.jp/shop/lineup/" target="_blank" rel="noreferrer" className="flex items-center justify-between rounded-lg border border-primary-600 bg-white px-5 py-4 font-bold text-primary-700 hover:bg-primary-50">販売中のスマホを見る<span>↗</span></a></div>
        <p><Link to="/compare">ほかの通信会社と同じ条件で比較する →</Link></p>
      </section>
    </>
  );
}
